export default {
    getaccountinfo() {
        if(this.intervalHand) {
            clearTimeout(this.intervalHand)
        }
        this.$api.accountinfo(this.token, this.userName).then(res => {
            if (res.data.code === 200) {
                this.$store.commit('UPDATE_ACCOUNT_INFO', res.data.data)
            }
            if (this.isopen) {
                this.intervalHand = setTimeout(() => {
                    this.getaccountinfo();
                }, 3000)
            }
        })
    },
}
